export default __webpack_public_path__ + "static/roux-4969c39ff36f53fa7a1bc6b46545bde5.svg";